import { render, staticRenderFns } from "./Version.vue?vue&type=template&id=fba41b3e&scoped=true";
import script from "./Version.vue?vue&type=script&lang=js";
export * from "./Version.vue?vue&type=script&lang=js";
import style0 from "./Version.vue?vue&type=style&index=0&id=fba41b3e&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "fba41b3e", null);
export default component.exports;